import React from 'react';
import ReactDOM from 'react-dom';
import App from '../Components/App';
import { Provider } from 'react-redux';
import { store } from '../Components/store';
import { FABRIC_LOGICAL_WIDTH, FABRIC_LOGICAL_HEIGHT } from '../Components/canvasConstants';

import './index.css';

document.addEventListener('DOMContentLoaded', bootProductCustomizer);
document.addEventListener('turbolinks:load', bootProductCustomizer);

function bootProductCustomizer() {
  const node = document.getElementById('rootFromRuby');
  // Landing page (`products/index`) has no mount node; only `show` runs the customizer.
  if (!node) return;

  let data;
  try {
    const raw = node.dataset.productJson;
    if (!raw) {
      console.error('Product customizer: missing data-product-json on #rootFromRuby');
      return;
    }
    data = JSON.parse(raw);
  } catch (err) {
    console.error('Product customizer: invalid JSON', err);
    return;
  }

  const front_image = node.dataset.frontImage || '';
  const back_image = node.dataset.backImage || '';
  const authtoken = node.dataset.authtoken || '';
  node.remove();

  function hexToRgb(hex) {
    if (!hex) return { r: 0, g: 0, b: 0 };
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : { r: 0, g: 0, b: 0 };
  }

  const defaultWorkArea = {
    front: { left: 0, top: 0, width: FABRIC_LOGICAL_WIDTH, height: FABRIC_LOGICAL_HEIGHT, workAreaWidth: '10', workAreaHeight: '10' },
    back: { left: 0, top: 0, width: FABRIC_LOGICAL_WIDTH, height: FABRIC_LOGICAL_HEIGHT, workAreaWidth: '10', workAreaHeight: '10' }
  };

  /** Merge API work_area with defaults; coerce numbers; avoid 0×N frames (shows as a thin red stroke only). */
  function clampWorkAreaSide(side, defaults) {
    const raw = { ...defaults, ...(side && typeof side === 'object' ? side : {}) };
    const num = (v, d) => {
      const n = Number(v);
      return Number.isFinite(n) ? n : d;
    };
    const left = num(raw.left, defaults.left);
    const top = num(raw.top, defaults.top);
    let width = num(raw.width, defaults.width);
    let height = num(raw.height, defaults.height);
    if (!(width > 0)) width = defaults.width;
    if (!(height > 0)) height = defaults.height;
    return {
      ...raw,
      left,
      top,
      width,
      height,
      workAreaWidth: raw.workAreaWidth != null ? String(raw.workAreaWidth) : defaults.workAreaWidth,
      workAreaHeight: raw.workAreaHeight != null ? String(raw.workAreaHeight) : defaults.workAreaHeight,
    };
  }

  const wa = data.work_area && typeof data.work_area === 'object' ? data.work_area : null;
  const workArea = {
    front: clampWorkAreaSide(wa && wa.front, defaultWorkArea.front),
    back: clampWorkAreaSide(wa && wa.back, defaultWorkArea.back),
  };

  const engColor = hexToRgb(data.engraving_color);
  const { title, id, woo_id } = data;
  const front_variant_label = data.front_variant_label || 'VARIANTE 1';
  const back_variant_label = data.back_variant_label || 'VARIANTE 2';
  let { front_side_price, back_side_price, price } = data;
  back_side_price = parseFloat(back_side_price || 0).toFixed(2);
  front_side_price = parseFloat(front_side_price || 0).toFixed(2);
  price = parseFloat(price || 0).toFixed(2);
  const emptyImg = (v) => (!v || v === '[]' || v === 'null') ? '' : v;
  const product = {
    title,
    woo_id,
    id,
    workArea,
    engColor,
    front_variant_label,
    back_variant_label,
    front_image: emptyImg(front_image),
    back_image: emptyImg(back_image),
    authtoken,
    front_side_price,
    back_side_price,
    price
  };
  store.dispatch({
    type: 'ADD_PRODUCT',
    payload: product
  });
  ReactDOM.render(
    <Provider store={store}>
      <App  />
    </Provider>,
    document.body.appendChild(document.createElement('div')),
  );
}
